import store from '@/store';

export default {
  setShowData(rawData) {
    const selectingLocale = store.state.locale.selectingLocale;
    const {
      is_in_stats,
      question_type_setting,
      answer_setting,
      question_template_setting_items,
      unit,
    } = rawData.last_version;
    let result = {
      ...rawData,
      last_version: {
        ...rawData.last_version,
        isInStats: [is_in_stats],
        is_in_stats: is_in_stats === 1 ? [is_in_stats] : null,
        question_type: {
          ...question_type_setting,
          text: question_type_setting.locales[selectingLocale].name,
        },
      },
    };
    if (question_type_setting.value === 'single-choice') {
      const optionInfo = question_template_setting_items.map(rawOption => {
        const {
          answer_setting_item,
          question_template_setting_items: rawSubOption
        } = rawOption;
        const answer_setting_items = rawSubOption && rawSubOption.length
          ? rawSubOption.map(rawSubItem => rawSubItem.answer_setting_item)
          : [];
        return {
          ...answer_setting_item,
          answer_setting_items,
        }
      });
      result.last_version = {
        ...result.last_version,
        optionSetting: answer_setting.name,
        optionInfo,
        option: answer_setting,
      };
    } else if (question_type_setting.value === 'num') {
      result = {
        ...result,
        last_version: {
          ...result.last_version,
          numericalComparisonSettingInfo: answer_setting.name,
          numericalComparisonSetting: {
            id: answer_setting.id,
            value: answer_setting.type,
          },
          unit: unit ? unit : '',
        }
      };
      if (answer_setting.type === 'control-limit') {
        const {control_limit_lower, control_limit_upper, spec_limit_lower, spec_limit_upper} = question_template_setting_items[0];
        result.last_version = {
          ...result.last_version,
          control_limit_lower,
          control_limit_upper,
          spec_limit_lower,
          spec_limit_upper
        };
      } else if (answer_setting.type === 'custom-num') {
        result.last_version = {
          ...result.last_version,
          numericalComparisonConditionSettingInfo: question_template_setting_items,
          numericalComparisonConditionSetting: question_template_setting_items.map(item => {
            const {value_operator, value, risk_level, limit_lower, limit_upper} = item;
            return  {
              value_operator,
              risk_level,
              limit_lower: value_operator === 'in' || value_operator === 'not_in' ? limit_lower : value,
              limit_upper: value_operator === 'in' || value_operator === 'not_in' ? limit_upper : null,
            };
          }),
        };
      }
    }
    return result;
  },
  setSubmitData(rawData){
    const {question_type, is_in_stats, option,
      act_version_alls,article_versions, attaches, checklist_question_template,
      checklist_template_versions, effects, locales, status,numericalComparisonSetting,
      control_limit_lower, control_limit_upper, spec_limit_lower, spec_limit_upper,
      numericalComparisonConditionSetting, unit,
    } = rawData;
    const getIsInStats = ({isInStats, quesTypeValue, numConditionTypeValue}) => {
      if (quesTypeValue === 'date' || quesTypeValue === 'text') return 0;
      else if (quesTypeValue === 'single-choice') return isInStats === 1 ? 1 : 0;
      else if (quesTypeValue === 'num') return numConditionTypeValue === 'num-only'
        ? 0
        : isInStats === 1
        ? 1
        : 0;
    }
    let result = {
      act_version_alls,article_versions, attaches, checklist_question_template,
      checklist_template_versions, effects, locales, status,
      question_type_setting: question_type.id,
      is_in_stats: is_in_stats && is_in_stats[0]
        ? getIsInStats({isInStats: is_in_stats[0], quesTypeValue: question_type.value, numConditionTypeValue: numericalComparisonSetting.value})
        : 0,
    };
    if (question_type.value === 'single-choice') {
      const {id: optionId, optionItemList} = option;
      const question_template_setting_items = optionItemList.map(item => {
        const {id: itemId, risk_level, has_child, has_remark, answer_setting_items} = item;
        return {
          spec_limit_lower: null,
          spec_limit_upper: null,
          control_limit_lower: null,
          control_limit_upper: null,
          limit_lower: null,
          limit_upper: null,
          score_setting: null,
          value: null,
          value_operator: null,
          risk_level,
          has_child,
          has_remark,
          answer_setting_item: itemId,
          question_template_setting_items: answer_setting_items.map(subItem => {
            return {
              spec_limit_lower: null,
              spec_limit_upper: null,
              control_limit_lower: null,
              control_limit_upper: null,
              limit_lower: null,
              limit_upper: null,
              score_setting: null,
              value: null,
              value_operator: null,
              risk_level: subItem.risk_level,
              has_child: subItem.has_child,
              has_remark: subItem.has_remark,
              answer_setting_item: subItem.id,
            }
          }),
        };
      })
      result = {
        ...result,
        answer_setting: optionId,
        question_template_setting_items,
      };
    } else if (question_type.value === 'num') {
      result = {
        ...result,
        answer_setting: numericalComparisonSetting.id,
        unit,
      };
      if (numericalComparisonSetting.value === 'control-limit') {
        result = {
          ...result,
          question_template_setting_items: [{
            control_limit_lower,
            control_limit_upper,
            spec_limit_lower,
            spec_limit_upper,
          }]
        };
      } else if (numericalComparisonSetting.value === 'custom-num') {
        const question_template_setting_items = numericalComparisonConditionSetting.map(condition => {
          const {limit_lower, limit_upper, risk_level, value_operator} = condition;
          return value_operator === 'in' || value_operator === 'not_in'
            ? {limit_lower, limit_upper, risk_level, value_operator}
            : {value: limit_lower, risk_level, value_operator};
        })
        result = {
          ...result,
          question_template_setting_items,
        };
      }
    }
    return result;
  }
}